import { render } from "./InvitationList.vue?vue&type=template&id=2ea3fefd&ts=true"
import script from "./InvitationList.vue?vue&type=script&lang=ts"
export * from "./InvitationList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserForm/InvitationList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ea3fefd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ea3fefd', __exports__)) {
    api.reload('2ea3fefd', __exports__)
  }
  
  module.hot.accept("./InvitationList.vue?vue&type=template&id=2ea3fefd&ts=true", () => {
    api.rerender('2ea3fefd', render)
  })

}


export default __exports__